// Core
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LayoutComponent } from "./core/components/layout/layout.component";
// Components
import { NotFoundComponent } from "./core/components/not-found/not-found.component";

/** The application's top level routing table. */
const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "treatment-create/:contractId",
        loadChildren:
          () => import('./modules/treatment-create/treatment-create.module').then(m => m.TreatmentCreateModule),
      },
      {
        path: "**",
        component: NotFoundComponent,
        data: { title: "Page Not Found" },
      },
    ],
  },
];

/** The top level application router. */
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
